var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner)?_c('div',{staticClass:"o-banner"},[_c('a',{attrs:{"href":_vm.banner.link_url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.banner.name,"alt":"Agrii info"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }